import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useNoticeBannersStackContext } from '@sg/garnish';

export const useNotifyStripeCancel = () => {
  const { push: addNoticeBanner } = useNoticeBannersStackContext();
  const { formatMessage } = useIntl();
  const message = formatMessage(messages.message);

  return useCallback(
    (text = message) => {
      addNoticeBanner({ text, palette: 'neutral' });
    },
    [message, addNoticeBanner],
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  message: {
    defaultMessage: 'Order submission has been canceled.',
    description: 'Stripe Payment | Cancelation',
  },
});
